import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import * as moment from 'moment'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { getImageRedirectUrl } from '../../../../../../helper/common'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { StateServices } from '../../../../../services/state.services'
import { SharedServices } from '../../../../../services/shared.services'
import { DatepickerHelper } from '../../../../../../helper/datepicker.helper'

@Component({
    selector: 'app-search-form-settings',
    templateUrl: './search-form-settings.component.html',
    styleUrls: [
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        './search-form-settings.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class SearchFormSettingsComponent implements OnInit, OnDestroy {

    arrIdClickedTabs: any[] = []
    arrDataClickedTabs: any[] = []
    // arrayAlignerTabs: any[] = [];
    jsonDataSave: any = {}
    arrayDate: any[] = []
    optionsStartDate: any = {
        viewMode: 'days',
        ...DatepickerHelper.BASE_OPTIONS,
    }

    optionsBirthday: any = {
        viewMode: 'years',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }

    optionsStartday: any = {
        viewMode: 'years',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }

    optionsLastday: any = {
        viewMode: 'years',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }

    arrayLoadImage: any[] = []
    arrayMatrixImage: any[] = []
    arrImageHash: any[] = []
    arrImage: any[] = []

    hashImages: any
    animationDuration: any = 2800

    getDefaultArrTabs: any
    en: any
    showEN = true

    changeLangguage: any
    ratatepropertyName: any = ''
    jsonDateShow: any = {}
    isChooseDate: Boolean = false
    @Input() arrayAlignerTabs: { propertyName: string, [key: string]: any }[] = []
    @Input() pageNameUse?: any = ''

    @Output() emitDataSearchOut: EventEmitter<any> = new EventEmitter<any>()
    @Output() activeHotKey: EventEmitter<any> = new EventEmitter<any>()
    //close three option by element "optionFillter" in arrDataClickedTabs for select option date 'day', 'week', 'month', 'year' don't focus together 
    // private birthDay_filter: any = 'day'
    // private lastDay_filter: any = 'day'
    // private startDay_filter: any = 'day'
    private lastSend_filter: string = 'day'
    //edit 23/12/20
    arrIdClickedTabsLength: any = 0;

    constructor(
        private authData: AuthService,
        private restApi: RestServices,
        public matrixServices: MatrixServices,
        private stateServices: StateServices,
        private _sharedService: SharedServices,
    ) {
    }

    ngOnInit() {
        this.stateServices.emitChangeTabName('formSetting')
        // this.initArrMatrix(this.arrayAlignerTabs);
        this.getArrHash()
        const initIdsTabs = this.stateServices.getSearchTabIdsByPageNameUse(this.pageNameUse)
        if (initIdsTabs && initIdsTabs['arrIdClickedTabs']) {
            this.arrIdClickedTabs = initIdsTabs['arrIdClickedTabs']
            this.sortingSearchFilters()
            this.arrayAlignerTabs = initIdsTabs['arrayAlignerTabs']
            this.jsonDataSave = initIdsTabs['jsonDataSearch']
            this.arrDataClickedTabs = []
            this.arrayAlignerTabs.forEach((el, i) => {
                const checkInArr = this.arrIdClickedTabs.indexOf(el['propertyName'])
                if (checkInArr != -1) {
                    this.arrDataClickedTabs.push(el)
                }
            })
            this.emitDataSearch()
        } else {
            this.arrIdClickedTabs = []
            this.arrDataClickedTabs = []
            this.jsonDataSave = {}
        }
        this.getDefaultArrTabs = this.stateServices.changeEmittedDefaultArrSelect$.subscribe(res => {
            if (res && res['default']) {
                if (this.arrayAlignerTabs.length == 0) {
                    this.arrayAlignerTabs = res['default']
                    this.initArrMatrix(this.arrayAlignerTabs)
                }
            }
        })
        this.en = this.authData.showLang(true)
        this.changLanguage()

        if (this.jsonDataSave && Object.keys(this.jsonDataSave).length > 0) {
            Object.entries(this.jsonDataSave).forEach(([key, value]) => {
                let valueToMoment = null
                if (
                    typeof value === 'object'
                    && value['$gte']
                    && typeof value['$gte'] === 'number'
                ) {
                    valueToMoment = moment(value['$gte'])
                } else if (typeof value === 'number') {
                    valueToMoment = moment(value)
                }
                if (valueToMoment && (valueToMoment as moment.Moment).isValid()) {
                    this.jsonDateShow[key] = valueToMoment
                }
            })
        }
    }

    changLanguage() {
        this.changeLangguage = this._sharedService.changeEmittedChangeLanguage$.subscribe(change => {
            if (change) {
                return this.en = this.authData.showLang(this.showEN)
            }
        })
    }

    getTabsTitle(option2General) {
        if (option2General['en']) {
            if (this.en) {
                return this.en[option2General['en']]
            }
        }
        return option2General['title']
    }

    ngOnDestroy() {
        if(this.hashImages)
            this.hashImages.unsubscribe()
        if(this.getDefaultArrTabs)
            this.getDefaultArrTabs.unsubscribe()
        if(this.changeLangguage)
            this.changeLangguage.unsubscribe()
    }

    functionEmitDataSearch(propertyName?: any) {
        const dataSearch: any = {}
        dataSearch['arrIdClickedTabs'] = this.arrIdClickedTabs
        dataSearch['IdClickedTab'] = propertyName
        dataSearch['jsonDataSearch'] = this.jsonDataSave
        this.emitDataSearchOut.emit(dataSearch)
    }

    focusInput(event) {
        this.activeHotKey.emit(true)
    }

    blurInput(event) {
        this.activeHotKey.emit(false)
    }

    defaultRotate(event, propertyName, rotate, i) {
        event.stopPropagation()
        this.ratatepropertyName = propertyName
        const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + i)
        const imageId: HTMLElement = document.getElementById('imageId' + i)
        this.matrixServices.defaultRotate(i, this.matrixServices.arrRotate[i], imageId, imageWrapper, rotate, this.matrixServices.arrFlip[i]['horizontalFlip'], this.matrixServices.arrFlip[i]['verticalFlip'])
    }

    getArrHash() {
        this.hashImages = this.stateServices.changeEmittedHash$.subscribe(response => {
            const tabs = this.stateServices.returnViewAligner()
            if (response && response['formSetting'] && this.ratatepropertyName && this.ratatepropertyName != '' && tabs == 'searchData') {
                const index = response['index']
                const data: any[] = response['formSetting']
                const jsonChangeMatrix = jQuery.extend(true, {}, data[index])
                const tmpDataItem = jQuery.extend(true, {}, this.jsonDataSave[this.ratatepropertyName])
                tmpDataItem['matrix'] = jQuery.extend(true, [], jsonChangeMatrix['matrix'])
                this.jsonDataSave[this.ratatepropertyName] = tmpDataItem
                this.emitDataSearch()
            }
        })
    }

    emitDataSearch(propertyName? : any) {
        this.functionEmitDataSearch(propertyName)
    }

    initArrMatrix(arrayGeneral: any[] = []) {
        this.arrImage = []
        this.arrImageHash = []
        //matrix
        this.arrayMatrixImage = []
        const matrix = [1, 0, 0, 1]
        const arrRotate: any[] = []
        const arrStyleImage: any[] = []
        const arrFlip: any[] = []
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        this.arrayLoadImage = []
        let tpmArrImageHash: any[] = []
        let tmpArrayMatrixImage: any[] = []
        let tmpArrImage: any[] = []
        let dxdyMatrix: any[] = []

        if (arrayGeneral && arrayGeneral.length > 0) {
            arrayGeneral.forEach((el, i) => {
                if (el && Object.keys(el).length > 0) {
                    const propertyName = el['propertyName']
                    if (this.jsonDataSave[propertyName]) {
                        if (typeof this.jsonDataSave[propertyName] == 'object' && !Array.isArray(this.jsonDataSave[propertyName])) {
                            const url = getImageRedirectUrl(this.jsonDataSave[propertyName]['id'])
                            tmpArrImage.push(url)
                            tpmArrImageHash.push(this.jsonDataSave[propertyName])
                            const tmpMatrix = this.jsonDataSave[propertyName]['matrix']
                            tmpArrayMatrixImage.push(tmpMatrix)
                        } else {
                            tpmArrImageHash.push({})
                            tmpArrImage.push('')
                            tmpArrayMatrixImage.push(matrix)
                        }
                    } else {
                        tpmArrImageHash.push({})
                        tmpArrImage.push('')
                        tmpArrayMatrixImage.push(matrix)
                    }
                    // this.arrImage.push('');
                    // this.arrImageHash.push({});
                    arrRotate.push(0)
                    arrStyleImage.push('')
                    arrFlip.push(jsonFlip)
                    dxdyMatrix.push(0)
                    // this.arrayMatrixImage.push(matrix);
                    this.arrayLoadImage.push(false)

                    if (el['schema'] && el['schema']['type'] === 'date' && el['schema']['uiOptions']) {
                        const behavior = el['schema']['uiOptions']['behavior']
                        if (
                            behavior === 'recentToday'
                            || behavior === 'startdaySingle'
                            || behavior === 'lastdaySingle'
                            || behavior === 'recentThreeToday'
                        ) {
                            const cachedSearchData = this.stateServices.getSearchTabIdsByPageNameUse(this.pageNameUse)
                            if (
                                cachedSearchData
                                && cachedSearchData.jsonDataSearch
                                && cachedSearchData.jsonDataSearch[propertyName]
                            ) {
                                const cachedValue = cachedSearchData.jsonDataSearch[propertyName]
                                if (typeof cachedValue === 'number') {
                                    this.arrayDate[i] = moment(cachedValue)
                                } else if (
                                    typeof cachedValue === 'object'
                                    && cachedValue['$gte']
                                    && typeof cachedValue['$gte'] === 'number'
                                ) {
                                    this.arrayDate[i] = moment(cachedValue['$gte'])
                                }
                            } else {
                                this.arrayDate[i] = moment(moment().valueOf())
                            }
                        }
                    }
                }
            })
            this.arrayMatrixImage = jQuery.extend(true, [], tmpArrayMatrixImage)
            this.arrImage = jQuery.extend(true, [], tmpArrImage)
            this.arrImageHash = jQuery.extend(true, [], tpmArrImageHash)

            this.matrixServices.arrImageHash = jQuery.extend(true, [], this.arrImageHash)
            this.matrixServices.arrRotate = jQuery.extend(true, [], arrRotate)
            this.matrixServices.arrStyleImage = jQuery.extend(true, [], arrStyleImage)
            this.matrixServices.arrFlip = jQuery.extend(true, [], arrFlip)
            this.matrixServices.dXdYMatrixCanvas = jQuery.extend(true, [], dxdyMatrix)
        }
    }

    removeSearch(propertyName) {
        this.jsonDataSave[propertyName] = ''
        this.jsonDateShow[propertyName] = ''
        const arrayCheckSplice: any[] = jQuery.extend(true, [], this.arrDataClickedTabs)
        const indexSplice = this.getIndexInsert(propertyName, arrayCheckSplice)

        this.arrImageHash.splice(indexSplice, 1)
        this.arrImage.splice(indexSplice, 1)
        this.arrayMatrixImage.splice(indexSplice, 1)

        this.matrixServices.arrImage.splice(indexSplice, 1)
        this.matrixServices.arrImageHash.splice(indexSplice, 1)
        this.matrixServices.arrStyleImage.splice(indexSplice, 1)
        this.matrixServices.arrFlip.splice(indexSplice, 1)
        this.matrixServices.arrRotate.splice(indexSplice, 1)
        this.matrixServices.dXdYMatrixCanvas.splice(indexSplice, 1)

        this.arrDataClickedTabs = []
        const findIndex = this.arrIdClickedTabs.findIndex(el => {
            return el == propertyName
        })
        this.arrayAlignerTabs.forEach((el, i) => {
            const checkInArr = this.arrIdClickedTabs.indexOf(el['propertyName'])
            if (checkInArr !== -1) {
                if (checkInArr === findIndex) {
                    if (el['optionFillter']) {
                        delete el['optionFillter']   
                    }
                } else {
                    this.arrDataClickedTabs.push(el)
                }
            }
        })
        this.arrIdClickedTabs.splice(findIndex, 1)
        // this.resetFilterDate(propertyName)
        this.emitDataSearch()
    }

    onDeleteImage(propertyName, index) {
        $('#inputImage' + index).val('')
        this.arrImage[index] = ''
        this.arrImageHash[index] = {}
        this.matrixServices.removePhoto(index)
        this.jsonDataSave[propertyName] = undefined
        this.emitDataSearch()
    }

    getUrlImage(propertyName, index) {
        if (this.jsonDataSave[propertyName]) {
            const url = getImageRedirectUrl(this.jsonDataSave[propertyName]['id'] + '?type=medium')
            this.arrImage[index] = url
            this.arrImageHash[index] = this.jsonDataSave[propertyName]
            const matrix = this.jsonDataSave[propertyName]['matrix']
            this.arrayMatrixImage[index] = matrix
            return url
        }
        return ''
    }

    allowDrop(e) {
        e.preventDefault()
    }

    drop(e, propertyName, index) {
        e.preventDefault()
        // if (this.matrixServices.arrFlip.length < this.arrDataClickedTabs.length) {
        //     this.initArrMatrix(this.arrDataClickedTabs);
        // }
        if (!this.matrixServices.arrFlip[index]) {
            const jsonFlip: any = {}
            jsonFlip['horizontalFlip'] = 1
            jsonFlip['verticalFlip'] = 1
            this.matrixServices.arrRotate[index] = 0
            this.matrixServices.arrStyleImage[index] = ''
            this.matrixServices.arrFlip[index] = jsonFlip
            this.matrixServices.dXdYMatrixCanvas[index] = 0
            this.arrayLoadImage[index] = true
        }
        const reader = new FileReader()
        reader.readAsDataURL(e.dataTransfer.files[0])
        const excrptFile: any = 'image/'
        const tmpFile: any = e.dataTransfer.files[0]
        const typeFile: String = tmpFile['type']
        this.animationDuration = 3500
        this.arrayLoadImage[index] = true
        if (typeFile.includes(excrptFile) && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // this.animationDuration = 2800;
            // this.arrLoading[ind] = true;
            reader.onload = (event: any) => {
                // this.getUrlImage(this.index, event.target.result);
                // this.url = event.target.result;
                // this.arrShowStatus[ind] = true;
            }
            // const arrUploadImage: any[] = this.arrRegistrationFace;
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(e.dataTransfer.files.item(0), tokenReNew).subscribe(
                    success => {
                        const jsonImage = {}
                        jsonImage['id'] = success['hash']
                        jsonImage['matrix'] = [1, 0, 0, 1]
                        this.jsonDataSave[propertyName] = jsonImage
                        this.emitDataSearch()
                        this.arrayMatrixImage = [1, 0, 0, 1]
                        this.arrImageHash[index] = jsonImage
                        const url = getImageRedirectUrl(success['hash'] + '?type=medium')
                        this.arrImage[index] = url
                        // this.emitJsonSaveFormSetting();
                        this.arrayLoadImage[index] = false
                    },
                )
            })
        }
    }

    handleFileInput(files: FileList, propertyName, event, index) {
        if (event.target.files && event.target.files[0]) {
            if (!this.matrixServices.arrFlip[index]) {
                const jsonFlip: any = {}
                jsonFlip['horizontalFlip'] = 1
                jsonFlip['verticalFlip'] = 1
                this.matrixServices.arrRotate[index] = 0
                this.matrixServices.arrStyleImage[index] = ''
                this.matrixServices.arrFlip[index] = jsonFlip
                this.matrixServices.dXdYMatrixCanvas[index] = 0
                this.arrayLoadImage[index] = true
            }
            // this.tabUploadImage = this.TabRegistrationFaceClass;
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                // this.animationDuration = 2800;
                // this.arrLoading[ind] = true;
                reader.onload = (event: any) => {
                    // this.getUrlImage(this.index, event.target.result);
                    // this.url = event.target.result;
                    // this.arrShowStatus[ind] = true;
                }
                // const arrUploadImage: any[] = this.arrRegistrationFace;
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonImage = {}
                            jsonImage['id'] = success['hash']
                            jsonImage['matrix'] = [1, 0, 0, 1]
                            this.jsonDataSave[propertyName] = jsonImage
                            this.emitDataSearch()
                            this.arrayMatrixImage = [1, 0, 0, 1]
                            this.arrImageHash[index] = jsonImage
                            const url = getImageRedirectUrl(success['hash'] + '?type=medium')
                            this.arrImage[index] = url
                            // this.emitJsonSaveFormSetting();
                            this.arrayLoadImage[index] = false
                        },
                    )
                })
            }
        }
    }

    onChangInputValue(event, propertyName) {
        const textValue = event.target.value
        this.jsonDataSave[propertyName] = textValue.replace(/(?:\r\n|\r|\n)/g, '\\n')
        this.emitDataSearch()
        // this.emitJsonSaveFormSetting();
    }

    getShowDate(propertyName, index, birthDayFilter = false, startDayFilter = false, lastDayFilter = false) {
        const findData = this.arrayAlignerTabs.find(el => {
            return el['propertyName'] == propertyName
        })
        let showDate = 'Click to Select'
        const indexInput = this.arrayAlignerTabs.findIndex(item => item.propertyName === propertyName)
        
        if (this.jsonDateShow[propertyName] && this.jsonDateShow[propertyName] != '') {
            showDate = this.getDateToday(this.jsonDateShow[propertyName], birthDayFilter, startDayFilter, lastDayFilter, index)
        } else {
            if (findData['schema'] && findData['schema']['uiOptions'] && findData['schema']['uiOptions']['behavior'] && (findData['schema']['uiOptions']['behavior'] == 'recentToday' || findData['schema']['uiOptions']['behavior'] == 'startdaySingle' || findData['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
                showDate = this.getDateToday()
                this.jsonDateShow[propertyName] = new Date()
                if (this.arrayDate[indexInput] == moment(moment().valueOf())) {
                    this.arrayDate[indexInput] = moment(moment().valueOf())
                }
            }
        }
        return showDate
    }

    /**
     * Generate a string represent the selected searching date depending on the filter type
     * @param datetime the datetime to be formatted
     * @param birthDayFilter boolean value, true if modify birthday, it will also change the context according to the filter.
     */
    getDateToday(datetime = new Date(), birthDayFilter = false, startDayFilter = false, lastDayFilter = false, index?: any) {
        if (datetime) {
            let momentObject = moment(datetime)
            let conviertWeekday = momentObject.format('ddd')
            if (birthDayFilter || startDayFilter || lastDayFilter) {
                let currentDate = momentObject.get('date')
                let month = momentObject.month() + 1
                const year = momentObject.year()

                let startWeek = momentObject.startOf('week').date()
                let startWeekMonth = momentObject.month() + 1
                const startWeekYear = momentObject.year()

                let endWeek = momentObject.endOf('week').date()
                let endWeekMonth = momentObject.month() + 1

                let convertedMonth = month + ''
                if (month < 10) {
                    convertedMonth = '0' + month
                }

                let convertedEndWeek = endWeek + ''
                if (endWeek < 10) {
                    convertedEndWeek = '0' + endWeek
                }
                let convertedEndWeekMonth = endWeekMonth + ''
                if (endWeekMonth < 10) {
                    convertedEndWeekMonth = '0' + endWeekMonth
                }

                let convertedStartWeek = startWeek + ''
                if (startWeek < 10) {
                    convertedStartWeek = '0' + startWeek
                }
                let convertedStartWeekMonth = startWeekMonth + ''
                if (startWeekMonth < 10) {
                    convertedStartWeekMonth = '0' + startWeekMonth
                }

                let convertedDate = currentDate + ''
                if (currentDate < 10) {
                    convertedDate = '0' + currentDate
                }

                let strReturn = ''
                let caseFileter = this.arrDataClickedTabs[index]['optionFillter']
                // if (startDayFilter) {
                //     caseFileter = this.startDay_filter
                // } else
                //  if (lastDayFilter) {
                //     caseFileter = this.lastDay_filter
                // }
                // filter cases
                switch (caseFileter) {
                    case 'day':
                        strReturn = year + '.' + convertedMonth + '.' + convertedDate + ' ' + conviertWeekday
                        break
                    case 'month':
                        strReturn = year + '.' + convertedMonth
                        break
                    case 'week':
                        strReturn = startWeekYear + '.' + convertedStartWeekMonth + '.' + convertedStartWeek + ' - ' + convertedEndWeekMonth + '.' + convertedEndWeek
                        break
                    case 'year':
                        strReturn = year + ''
                        break
                    default:
                        strReturn = year + '.' + convertedMonth + '.' + convertedDate
                }
                return strReturn
            }
            if (momentObject.format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                return moment().format('YYYY.MM.DD ddd')
            } else {
                return momentObject.format('YYYY.MM.DD ddd')
            }
        } else {
            return moment().format('YYYY.MM.DD ddd')
        }
    }

    prevDate(propertyName, number, index) {
        if (this.jsonDataSave[propertyName]) {
            const initDate = moment(this.jsonDateShow[propertyName])
            initDate.set({ hours: 10 })
            const subDate = initDate.subtract(number, 'days')
            if (moment(subDate).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                this.jsonDateShow[propertyName] = new Date()
            } else {
                this.jsonDataSave[propertyName] = moment(subDate).utc().startOf('day').valueOf()
                this.jsonDateShow[propertyName] = subDate
            }
            this.arrayDate[index] = moment(subDate.valueOf())
            this.emitDataSearch()
        }
    }

    /**
     * use current filter to save the passed date to state and create searching argument and emit it.
     * @param propertyName the data property name.
     * @param index number value, index of the data will be affected.
     * @param momentDate the new date after changed.
     */
    filterBirthDayListener(propertyName, index, momentDate = this.jsonDateShow[propertyName]) {
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                this.optionsBirthday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'week':
                this.optionsBirthday = {
                    format: 'YYYY.MM.DD',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'month':
                this.optionsBirthday = {
                    format: 'YYYY.MM',
                    viewMode: 'months',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'year':
                this.optionsBirthday = {
                    format: 'YYYY',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                this.optionsBirthday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
        }
        if (momentDate) {
            if (momentDate.format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                this.jsonDateShow[propertyName] = new Date()
            } else {
                let objSearch: any

                if (this.arrDataClickedTabs[index]['optionFillter'] == 'day') {
                    objSearch = momentDate.utc().valueOf()
                } else {
                    objSearch = this.searchBirthday(this.arrDataClickedTabs[index]['optionFillter'], momentDate.utc().valueOf())
                }
                this.jsonDataSave[propertyName] = objSearch
                this.jsonDateShow[propertyName] = momentDate
            }

            this.arrayDate[index] = moment(moment(momentDate).valueOf())
            this.emitDataSearch()
        }
    }

    filterStartDayListener(propertyName, index, momentDate = this.jsonDateShow[propertyName]) {
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                this.optionsStartday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'week':
                this.optionsStartday = {
                    format: 'YYYY.MM.DD',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'month':
                this.optionsStartday = {
                    format: 'YYYY.MM',
                    viewMode: 'months',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'year':
                this.optionsStartday = {
                    format: 'YYYY',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                this.optionsStartday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
        }
        if (momentDate) {
            const timestamp = moment(momentDate)
            timestamp.set({ hours: 10 })
            // if (timestamp.format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
            //     this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
            //     this.jsonDateShow[propertyName] = new Date()
            // } else {
            let objSearch: any

            if (this.arrDataClickedTabs[index]['optionFillter'] == 'day') {
                objSearch = timestamp.utc().valueOf()
            } else {
                objSearch = this.searchBirthday(this.arrDataClickedTabs[index]['optionFillter'], timestamp.utc().valueOf())
            }
            this.jsonDataSave[propertyName] = objSearch
            this.jsonDateShow[propertyName] = timestamp
            // }

            this.arrayDate[index] = moment(timestamp.valueOf())
            this.emitDataSearch()
        }
    }

    filterLastDayListener(propertyName, index, momentDate = this.jsonDateShow[propertyName]) {
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                this.optionsLastday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'week':
                this.optionsLastday = {
                    format: 'YYYY.MM.DD',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'month':
                this.optionsLastday = {
                    format: 'YYYY.MM',
                    viewMode: 'months',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            case 'year':
                this.optionsLastday = {
                    format: 'YYYY',
                    viewMode: 'years',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                this.optionsLastday = {
                    format: 'YYYY.MM.DD ddd',
                    viewMode: 'days',
                    ...DatepickerHelper.BASE_NONE_FORMAT_OPTIONS,
                }
        }
        if (momentDate) {
            const timestamp = moment(momentDate)
            timestamp.set({ hours: 10 })
            // if (timestamp.format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
            //     this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
            //     this.jsonDateShow[propertyName] = new Date()
            // } else {
            let objSearch: any

            if (this.arrDataClickedTabs[index]['optionFillter'] == 'day') {
                objSearch = timestamp.utc().valueOf()
            } else {
                objSearch = this.searchBirthday(this.arrDataClickedTabs[index]['optionFillter'], timestamp.utc().valueOf())
            }
            this.jsonDataSave[propertyName] = objSearch
            this.jsonDateShow[propertyName] = timestamp
            // }

            this.arrayDate[index] = moment(timestamp.valueOf())
            this.emitDataSearch()
        }
    }

    /**
     * Change date forward or backward (with fast-forward or fast-backward optional)
     * if fast-forward,the current time will be incremented
     * vise-versa with fast-backward
     * this method only work with birthday as default.
     * @param propertyName the object attribute to be filtered
     * @param index number value,
     * @param isFast boolean value, true will apply a big increment to the value. Default 10 for day and year, 4 for week, 12 for month (value is applied with filter type, meaning 10 for day/year, ...)
     * @param isForward boolean value, true if is on forward mode
     */
    toggleChangeBirthDate(propertyName, index, isFast = true, isForward = false) {
        let number = 1
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                if (isFast)
                    number = 10
                break
            case 'week':
                if (isFast)
                    number = 4
                break
            case 'month':
                if (isFast)
                    number = 12
                break
            case 'year':
                if (isFast)
                    number = 10
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                if (isFast)
                    number = 10
        }

        if (this.jsonDataSave[propertyName]) {
            const initDate = moment(this.jsonDateShow[propertyName])
            initDate.set({ hours: 10 })
            const units = this.arrDataClickedTabs[index]['optionFillter'] + 's' as moment.unitOfTime.DurationConstructor
            let subDateCal
            if (isForward) {
                subDateCal = initDate.add(number, units)
            } else {
                subDateCal = initDate.subtract(number, units)
            }

            this.filterBirthDayListener(propertyName, index, subDateCal)
        }
    }

    toggleChangeStartDate(propertyName, index, isFast = true, isForward = false) {
        let number = 1
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                if (isFast)
                    number = 10
                break
            case 'week':
                if (isFast)
                    number = 4
                break
            case 'month':
                if (isFast)
                    number = 12
                break
            case 'year':
                if (isFast)
                    number = 10
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                if (isFast)
                    number = 10
        }

        if (this.jsonDataSave[propertyName]) {
            const initDate = moment(this.jsonDateShow[propertyName])
            initDate.set({ hours: 10 })
            const units = this.arrDataClickedTabs[index]['optionFillter'] + 's' as moment.unitOfTime.DurationConstructor
            let subDateCal
            if (isForward) {
                subDateCal = initDate.add(number, units)
            } else {
                subDateCal = initDate.subtract(number, units)
            }

            this.filterStartDayListener(propertyName, index, subDateCal)
        }
    }

    toggleChangeLastDate(propertyName, index, isFast = true, isForward = false) {
        let number = 1
        switch (this.arrDataClickedTabs[index]['optionFillter']) {
            case 'day':
                if (isFast)
                    number = 10
                break
            case 'week':
                if (isFast)
                    number = 4
                break
            case 'month':
                if (isFast)
                    number = 12
                break
            case 'year':
                if (isFast)
                    number = 10
                break
            default:
                this.arrDataClickedTabs[index]['optionFillter'] = 'day'
                if (isFast)
                    number = 10
        }

        if (this.jsonDataSave[propertyName]) {
            const initDate = moment(this.jsonDateShow[propertyName])
            initDate.set({ hours: 10 })
            const units = this.arrDataClickedTabs[index]['optionFillter'] + 's' as moment.unitOfTime.DurationConstructor
            let subDateCal
            if (isForward) {
                subDateCal = initDate.add(number, units)
            } else {
                subDateCal = initDate.subtract(number, units)
            }

            this.filterLastDayListener(propertyName, index, subDateCal)
        }
    }

    nextDate(propertyName, number, index) {
        if (this.jsonDataSave[propertyName]) {
            const initDate = moment(this.jsonDateShow[propertyName])
            initDate.set({ hours: 10 })
            const subDate = initDate.add(number, 'days')
            if (moment(subDate).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                this.jsonDateShow[propertyName] = new Date()
            } else {
                this.jsonDataSave[propertyName] = moment(subDate).utc().startOf('day').valueOf()
                this.jsonDateShow[propertyName] = subDate
            }
            this.arrayDate[index] = moment(moment(subDate).valueOf())
            this.emitDataSearch()
        }
    }

    checkDatepickerLoading() {
        this.isChooseDate = true
        // DatepickerHelper.showWidget(true);
    }

    updateDatepicker(event, propertyName, index, isFilterBirth = false, isFilterStart = false, isFilterLast = false) {
        if (event) {
            if (this.isChooseDate) {
                const offsetTimezone = new Date().getTimezoneOffset()
                const addTime = 24 + (offsetTimezone / 60)
                const timestamp = moment(event['_d'])
                timestamp.set({ hours: 10 })
                if (isFilterBirth) {
                    this.filterBirthDayListener(propertyName, index, timestamp)
                } else if(isFilterStart) {
                    this.filterStartDayListener(propertyName, index, timestamp)
                } else if (isFilterLast) {
                    this.filterLastDayListener(propertyName, index, timestamp)
                } else {
                    if (moment(timestamp).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                        this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                        this.jsonDateShow[propertyName] = new Date()
                    } else {
                        this.jsonDataSave[propertyName] = moment(timestamp).add(addTime, 'hours').utc().startOf('day').valueOf()
                        this.jsonDateShow[propertyName] = timestamp
                    }

                    this.arrayDate[index] = moment(moment(timestamp).valueOf())
                    this.emitDataSearch()
                }
                this.isChooseDate = false
            }
            // this.emitJsonSaveFormSetting();
        }
    }

    getClassHide(title) {
        if (title && title != '') {
            return false
        }
        return true
    }

    changeOptionSchema(propertyName, optionsId, arrFirst) {
        const findData = this.arrayAlignerTabs.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findData['schema'] && findData['schema']['uiType'] == 'button' && findData['schema']['type'] == 'array') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            const check = tmpData.indexOf(optionsId)
            if (check == -1) {
                tmpData.push(optionsId)
            } else {
                const findIndex = tmpData.findIndex(el => {
                    return el == optionsId
                })
                if (findIndex != -1) {
                    tmpData.splice(findIndex, 1)
                }
            }
            const newArrMultiSelect: any[] = []
            arrFirst.forEach(element => {
                if (tmpData.indexOf(element['_id']) != -1) {
                    newArrMultiSelect.push(element['_id'])
                }
            })
            this.jsonDataSave[propertyName] = newArrMultiSelect
            this.emitDataSearch()
        } else if (findData['schema'] && findData['schema']['uiType'] == 'dialog' || findData['schema'] && findData['schema']['type'] == 'array' && findData['schema']['uiType'] != 'button') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            const check = tmpData.indexOf(optionsId)
            if (check == -1) {
                tmpData.push(optionsId)
            } else {
                const findIndex = tmpData.findIndex(el => {
                    return el == optionsId
                })
                if (findIndex != -1) {
                    tmpData.splice(findIndex, 1)
                }
            }
            const newArrMultiSelect: any[] = []
            arrFirst.forEach(element => {
                if (tmpData.indexOf(element['_id']) != -1) {
                    newArrMultiSelect.push(element['_id'])
                }
            })
            this.jsonDataSave[propertyName] = newArrMultiSelect
            this.emitDataSearch()
        } else {
            if (this.jsonDataSave[propertyName] == optionsId) {
                this.jsonDataSave[propertyName] = ''
                this.emitDataSearch()
            } else {
                this.jsonDataSave[propertyName] = optionsId
                this.emitDataSearch()
            }
        }
        // this.emitJsonSaveFormSetting();
    }

    getClassBtn(propertyName, optionsId) {
        const findData = this.arrayAlignerTabs.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findData['schema'] && findData['schema']['uiType'] == 'button') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            if (typeof tmpData == 'object') {
                if (tmpData && tmpData.length != 0) {
                    const check = tmpData.indexOf(optionsId)
                    if (check != -1) {
                        return true
                    }
                }
            } else {
                if (this.jsonDataSave[propertyName] == optionsId) {
                    return true
                }
            }
        } else if (findData['schema'] && findData['schema']['uiType'] == 'dialog') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            const check = tmpData.indexOf(optionsId)
            if (check != -1) {
                return true
            }
        } else {
            if (this.jsonDataSave[propertyName]) {
                if (this.jsonDataSave[propertyName] == optionsId) {
                    return true
                }
            }
        }
        return false
    }

    getClassHeadBtn(propertyName) {
        const check = this.arrIdClickedTabs.indexOf(propertyName)
        if (check != -1) {
            return true
        }
        return false
    }

    checkIsEmitSearch(propertyName) {
        const findItem = this.arrayAlignerTabs.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findItem && findItem['schema'] && findItem['schema']['type'] == 'date' && findItem['schema']['uiOptions'] && findItem['schema']['uiOptions']['behavior'] && (findItem['schema']['uiOptions']['behavior'] == 'recentToday' || findItem['schema']['uiOptions']['behavior'] == 'startdaySingle' || findItem['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
            return true
        }
        return false
    }

    getIndexInsert(propertyName, arrayChecks) {
        const findItem = arrayChecks.findIndex(el => {
            return el['propertyName'] == propertyName
        })
        if (findItem != -1) {
            return findItem
        }
        return -1
    }

    onSelectTab(propertyName, item) {
        if(!item['optionFillter'] && item['schema']['uiOptions'] && (item['schema']['uiOptions']['behavior'] == 'birthdaySingle' || item['schema']['uiOptions']['behavior'] == 'startdaySingle' || item['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
            item['optionFillter'] = 'day';
        }
        this.isChooseDate = false;
        const arrayCheckSplice: any[] = jQuery.extend(true, [], this.arrDataClickedTabs);
        const jsonFlip: any = {};
        jsonFlip['horizontalFlip'] = 1;
        jsonFlip['verticalFlip'] = 1;
        const arrdxdyMatrix = [1, 0];
        this.arrDataClickedTabs = [];
        this.jsonDataSave[propertyName] = '' || [];
        let searchFlg = false;
        if (this.arrIdClickedTabs.length == 0) {
            this.arrIdClickedTabs.push(propertyName)
            this.sortingSearchFilters()
            this.arrDataClickedTabs.push(item)
            const findIndexItem = this.arrDataClickedTabs.findIndex(el => {
                return el['propertyName'] == propertyName
            })
            const itemRemove = this.arrDataClickedTabs[findIndexItem]
            if (itemRemove['schema'] && itemRemove['schema']['type'] == 'date') {
                if (itemRemove['schema']['uiOptions'] && (itemRemove['schema']['uiOptions']['behavior'] == 'recentToday'
                || itemRemove['schema']['uiOptions']['behavior'] == 'startdaySingle' || itemRemove['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
                    this.arrayDate[findIndexItem] = moment(moment().valueOf());
                    this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf();
                    searchFlg = true;
                } else {
                    this.arrayDate[findIndexItem] = ''
                }
            }
            if (itemRemove['schema'] && (itemRemove['schema']['type'] == 'array' || itemRemove['schema']['type'] == 'string')) {
                if(this.pageNameUse != 'select-client'){
                    if (itemRemove['schema']['options'] && itemRemove['schema']['options'].length > 0) searchFlg = true;
                }
            }
            else {
                this.arrayDate[findIndexItem] = ''
            }
            // this.emitDataSearch(); close 23/11/20
        } else {
            const check = this.arrIdClickedTabs.findIndex(el => {
                return el == propertyName
            })
            if (check == -1) {
                this.arrIdClickedTabs.push(propertyName)
                this.sortingSearchFilters()
                this.arrayAlignerTabs.forEach((el, i) => {
                    const checkInArr = this.arrIdClickedTabs.indexOf(el['propertyName'])
                    if (checkInArr != -1) {
                        this.arrDataClickedTabs.push(el)
                    }
                })

                const findIndexItem = this.arrDataClickedTabs.findIndex(el => {
                    return el['propertyName'] == propertyName
                })
                const itemRemove = this.arrDataClickedTabs[findIndexItem]
                if (itemRemove['schema'] && itemRemove['schema']['type'] == 'date') {
                    if (itemRemove['schema']['uiOptions'] && (itemRemove['schema']['uiOptions']['behavior'] == 'recentToday'
                    || itemRemove['schema']['uiOptions']['behavior'] == 'startdaySingle' || itemRemove['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
                        this.arrayDate[findIndexItem] = moment(moment().valueOf());
                        this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf();
                        searchFlg = true;
                    } else {
                        this.arrayDate[findIndexItem] = ''
                    }
                }
                if (itemRemove['schema'] && (itemRemove['schema']['type'] == 'array' || itemRemove['schema']['type'] == 'string')) {
                    if(this.pageNameUse != 'select-client'){
                        if (itemRemove['schema']['options'] && itemRemove['schema']['options'].length > 0) searchFlg = true;
                    }
                }
                else {
                    this.arrayDate[findIndexItem] = ''
                }

                const arrayChecks = jQuery.extend(true, [], this.arrDataClickedTabs)
                const indexInsert = this.getIndexInsert(propertyName, arrayChecks)
                this.matrixServices.arrStyleImage.splice(indexInsert, 0, '')
                this.matrixServices.arrFlip.splice(indexInsert, 0, jsonFlip)
                this.matrixServices.dXdYMatrixCanvas.splice(indexInsert, 0, arrdxdyMatrix)
            } else {
                const findIndex = this.arrIdClickedTabs.findIndex(el => {
                    return el == propertyName
                })
                if (findIndex != -1) {
                    const findIndexItem = arrayCheckSplice.findIndex(el => {
                        return el['propertyName'] == propertyName
                    })
                    this.arrIdClickedTabs.splice(findIndex, 1)
                    const indexSplice = this.getIndexInsert(propertyName, arrayCheckSplice)
                    this.arrImageHash.splice(indexSplice, 1)
                    this.arrImage.splice(indexSplice, 1)
                    this.arrayMatrixImage.splice(indexSplice, 1)
                    this.matrixServices.arrImageHash.splice(indexSplice, 1)
                    this.matrixServices.arrStyleImage.splice(indexSplice, 1)
                    this.matrixServices.arrFlip.splice(indexSplice, 1)
                    this.matrixServices.arrRotate.splice(indexSplice, 1)
                    this.matrixServices.dXdYMatrixCanvas.splice(indexSplice, 1)
                    delete this.jsonDataSave[propertyName]
                    delete this.jsonDateShow[propertyName]
                    // this.resetFilterDate(propertyName)
                    const itemRemove = arrayCheckSplice[findIndexItem]
                    if (itemRemove['schema'] && itemRemove['schema']['type'] == 'date') {
                        if (itemRemove['schema']['uiOptions'] && (itemRemove['schema']['uiOptions']['behavior'] == 'recentToday'
                        || itemRemove['schema']['uiOptions']['behavior'] == 'startdaySingle' || itemRemove['schema']['uiOptions']['behavior'] == 'lastdaySingle')) {
                            this.arrayDate[findIndexItem] = moment(moment().valueOf());
                            this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf();
                            searchFlg = true;
                        } else {
                            this.arrayDate[findIndexItem] = ''
                        }
                    } else {
                        this.arrayDate[findIndexItem] = ''
                    }
                    this.arrayAlignerTabs.forEach((el, i) => {
                        const checkInArr = this.arrIdClickedTabs.indexOf(el['propertyName'])
                        if (checkInArr != -1) {
                            this.arrDataClickedTabs.push(el)
                        }
                    })
                }
            }
        }
        //edit 23/12/20
        if(this.arrIdClickedTabs.length < this.arrIdClickedTabsLength){
            searchFlg = true;
        }
        this.arrIdClickedTabsLength = this.arrIdClickedTabs.length;
        if(searchFlg){
            this.emitDataSearch(propertyName);
        }
    }

    searchBirthday(type: string, time: number) {
        if (type == 'week') {
            let gte = moment(time).utc().startOf('week').valueOf()
            let lt = moment(gte).utc().add(1, 'week').valueOf()
            return {
                $gte: gte,
                $lt: lt,
            }
        } else if (type == 'month') {
            let gte = moment(time).utc().startOf('month').valueOf()
            let lt = moment(gte).utc().add(1, 'month').valueOf()
            return {
                $gte: gte,
                $lt: lt,
            }
        } else if (type == 'year') {
            let gte = moment(time).utc().startOf('year').valueOf()
            let lt = moment(gte).utc().add(1, 'year').valueOf()
            return {
                $gte: gte,
                $lt: lt,
            }
        } else {
            return time
        }
    }

    private sortingSearchFilters() {
        this.arrIdClickedTabs.sort((first, second) => {
            let firstIndex = null
            let secondIndex = null
            this.arrayAlignerTabs.every((tab, index) => {
                if (tab.propertyName == first) {
                    firstIndex = index
                } else if (tab.propertyName == second) {
                    secondIndex = index
                }

                return !(firstIndex !== null && secondIndex !== null)
            })
            return firstIndex - secondIndex
        })
    }

    getDatepickerOptions(setting) {
        if (setting === 'birthdaySingle') {
            return DatepickerHelper.BASE_NONE_TODAY_OPTIONS
        } else {
            return DatepickerHelper.BASE_OPTIONS
        }
    }

    // resetFilterDate(propertyName) {
    //     switch (propertyName) {
    //         case 'birthday':
    //             this.birthDay_filter = 'day';
    //             break;
    //         case 'startDate':
    //             this.startDay_filter = 'day';
    //             break;
    //         case 'lastDate':
    //             this.lastDay_filter = 'day';
    //             break;
    //         default:
    //             break;
    //     }
    // }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/setting-behaviour/search-form-settings/search-form-settings.component.ts